export const CreditCheckResponseType = {
    ERROR: 'ERROR',
    FAIL: 'FAIL',
    HOLD: 'HOLD',
    NOHIT: 'NOHIT',
    PASS: 'PASS'
}


// WEBPACK FOOTER //
// ./src/store/creditCheck/constants.ts